export class AddedRevenueValidation {
    public constructor(init?: Partial<AddedRevenueValidation>) {
      Object.assign(this, init);
    }
        isValid: boolean = false;
        rateAmountMessage: string;
        quantityMessage: string;
        descriptionMessage: string;
   }